import { useQuery } from "@tanstack/react-query";

import { getLearnedCountsByUser } from "@/api/wordProgress";
import { useAuthStore } from "@/store/authStore";

/** 세트별 학습 완료(known) 단어 수 조회 */
export function useLearnedCountsQuery() {
  const userId = useAuthStore(state => state.user?.id);

  return useQuery({
    queryKey: ["learnedCounts", userId],
    queryFn: () => getLearnedCountsByUser(userId!),
    enabled: Boolean(userId),
  });
}
